export default {
  dashboard: {
    access: {
      table: {
        last_event: "Last Events",
        personal: "Employee",
        terminal_type: "Terminal Type",
        general_info: "General Information",
        terminal: "Terminal",
        event_type: "Event Type",
        identity_type: "Identity Type",
        time: "Time",
        event: "Event",
        location: "Location",
        place: "Place",
        place_beacon: "Place Beacon",
        minor: "Minor",
        major: "Major",
        parent: "Parent",
        duration: "Duration",
        first_seen: "First Seen",
        last_seen: "Last Seen",
        max_person_count: "Max Person Count",
        begin_date_time: "Begin DateTime",
        end_date_time: "End DateTime",
        employee_dialog_title: "Employee Enter - Exit Information",
        empty_zone_message: "Empty Zone",
        loading_message: "Loading"
      },
      monthly_dashboard: "Monthly Dashboard",
      monthly_events: "Monthly Events",
      monthly_timesheet_report: "Late Clock In",
      absence: "Absence",
      expected:"Expected",
      incalculable: "Incalculable",
      lates: "Lates",
      overtime: "Overtime",
      early_leaver: "Early Clock Out",
      missing_time: "Missing Time",
      total_tardiness_average: "Late Clock In Average",
      total_leaver_average: "Early Clock Out Average",
      total_overtime_average: "Overtime Average",
      tardiness_minute: "Late Minute",
      early_minute: "Early Minute",
      overtime_minute: "Overtime Minute",
      short_minute: "min",
      today: "Today"
    },
    currency: {
      buying: "Buying",
      selling: "Selling",
      currencies: "Currency"
    },
    about: {
      about: "About",
      mission: "Mission",
      vision: "Vision"
    },
    menu_of_day: "The Menu of Day",
    messages: {
      no_data_reminders: "No data Reminders",
      no_data_messages: "No data Messages",
      no_data_leaves: "No data Time Off Requests",
      no_data_overtimes: "No data Overtime Requests",
      no_data_expenses: "No data Expense Requests",
      no_data_imprests: "No data Imprest Requests",
      no_data_incalculables: "No data Incalculables",
      no_data_absences: "No data Absences"
    },
    request_type: {
      leave: "Time Off Requests",
      overtime: "Overtime Requests",
      expense: "Expense Requests",
      imprest: "Imprest Requests"
    },
    weather_forecast: "Weather Forecast & Current Rates",
    reminder_tab_title: "Reminders",
    message_tab_title: "Messages",
    data_type_enum: {
      LEAVE_REQUEST: "Time Off Requests",
      ACTIVITY: "Activities",
      REMINDER: "Reminders"
    }
  }
};
